module.exports = __webpack_public_path__ + "media/1.1ce562ce.mp3";